import { render, staticRenderFns } from "./BrokerFirmOrderSummary.vue?vue&type=template&id=17b3cb18&scoped=true"
import script from "./BrokerFirmOrderSummary.vue?vue&type=script&lang=js"
export * from "./BrokerFirmOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./BrokerFirmOrderSummary.vue?vue&type=style&index=0&id=17b3cb18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b3cb18",
  null
  
)

export default component.exports